import { useState, useEffect } from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaHeadset } from 'react-icons/fa';
import api from '../../utils/api';
import '../Account/Account.css';

export default function FloatSupport() {
  const [show, setShow] = useState(false);
  const [spUser, setSpUser] = useState('');
  const [spTitle, setSpTitle] = useState('');
  const [spMsg, setSpMsg] = useState('');
  const [spDone, setSpDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/support', { title: spTitle, desc: spMsg, userType: spUser });
      setSpDone(true);
      setSpUser(''); setSpTitle(''); setSpMsg('');
      setTimeout(() => { setSpDone(false); setShow(false); }, 2000);
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to submit. Please try again.');
    }
  };

  useEffect(() => {
    const handler = () => setShow(true);
    window.addEventListener('open-support', handler);
    return () => window.removeEventListener('open-support', handler);
  }, []);

  return (
    <>
      <button className="float-support-btn" onClick={() => setShow(true)}><FaHeadset /></button>

      {show && (
        <div className="modal-overlay" onClick={() => setShow(false)}>
          <div className="support-popup" onClick={e => e.stopPropagation()}>
            <div className="support-popup-header-wrap">
              <div className="support-popup-header">📞 Customer Support</div>
              <button className="support-popup-close" onClick={() => setShow(false)}>✕</button>
            </div>
            <div className="support-popup-body">
              <div className="support-popup-left">
                <h2>Let's talk<br />on something <span>great</span><br />together</h2>
                <div className="support-popup-email">✉️ support@justservice24.com</div>
                <div className="support-popup-socials">
                  <button className="support-social-btn"><FaFacebookF /></button>
                  <button className="support-social-btn"><FaTwitter /></button>
                  <button className="support-social-btn"><FaInstagram /></button>
                  <button className="support-social-btn"><FaLinkedinIn /></button>
                </div>
              </div>
              <div className="support-popup-right">
                {spDone ? (
                  <div style={{ textAlign: 'center', padding: '40px 0', color: '#16a34a', fontWeight: 700, fontSize: 16 }}>✅ Submitted Successfully!</div>
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="sp-group">
                      <label>Select User</label>
                      <select value={spUser} onChange={e => setSpUser(e.target.value)} required>
                        <option value="">-- Please Select --</option>
                        <option>Business User</option>
                        <option>User</option>
                      </select>
                    </div>
                    <div className="sp-group">
                      <label>Title</label>
                      <input placeholder="Title" value={spTitle} onChange={e => setSpTitle(e.target.value)} required />
                    </div>
                    <div className="sp-group">
                      <label>Message</label>
                      <textarea placeholder="Message" value={spMsg} onChange={e => setSpMsg(e.target.value)} required />
                    </div>
                    <button type="submit" className="sp-submit-btn">Submit</button>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
